import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import tw from './i18n/tw';
import ch from './i18n/ch';

i18next.addResourceBundle('en', 'products', en);
i18next.addResourceBundle('tw', 'products', tw);
i18next.addResourceBundle('ch', 'products', ch);

const ProductsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/products',
			component: React.lazy(() => import('./Products'))
		}
	]
};

export default ProductsConfig;
